export const PURPLE_THEME = 'purple'
export const BLUE_THEME = 'blue'
export const GREY_THEME = 'grey'
export const RED_THEME = 'red'
export const ORANGE_THEME = 'orange'
export const YELLOW_THEME = 'yellow'
